<template>
  <div class="telegram-setting">
    <c-btn
      color="primary"
      :href="model.telegram_link"
      target="_blank"
      :loading="loading"
    >{{ $t('msg.connectTelegramBot') }}</c-btn>
<!--    <v-switch-->
<!--      v-model="model.enable_every_day_tasks"-->
<!--      :label="$t('msg.everyMorningTasksForDay')"-->
<!--      hide-details="auto"-->
<!--      class="mt-4"-->
<!--      :dense="!isMobile"-->
<!--      @change="save"-->
<!--    ></v-switch>-->
<!--    <v-switch-->
<!--      v-model="model.enable_every_day_targets"-->
<!--      :label="$t('msg.everyMorningComingTargets')"-->
<!--      hide-details="auto"-->
<!--      class="mt-2"-->
<!--      :dense="!isMobile"-->
<!--      @change="save"-->
<!--    ></v-switch>-->
    <v-switch
      v-model="model.enable_reminder"
      :label="$t('msg.reminders')"
      hide-details="auto"
      class="mt-2"
      :dense="!isMobile"
      @change="save"
    ></v-switch>
  </div>
</template>

<script>
import CBtn from "@/components/ui/CBtn";

export default {
  components: {CBtn},
  data() {
    return {
      model: {
        enable_every_day_tasks: false,
        enable_every_day_targets: false,
        enable_reminder: false,
        telegram_link: null,
      },
      loading: false,
    };
  },
  methods: {
    loadTelegramSetting() {
      this.loading = true;
      this.$store.dispatch('loadTelegramSetting')
        .then(res => this.model = res)
        .finally(() => this.loading = false);
    },
    save() {
      this.$store.dispatch('updateTelegramSetting', {data: this.model});
    }
  },
  mounted() {
    this.loadTelegramSetting();
  }
}
</script>